import { DialogController } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';
import { applicationLogger } from '../logging/logger';
import { LocationApiProxy as ApplicationState } from "../models/location-api-proxy";

@autoinject
export class AdminDialog {
  dialogController: DialogController;
  applicationState: ApplicationState;
  constructor(applicationState: ApplicationState, dialogController: DialogController) {
    this.applicationState = applicationState;
    this.dialogController = dialogController;
  }

  activate() {
    applicationLogger.debug("AdminDialog activated.");
  }
}